function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "sound_mute"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m13.383 2.076c-.375-.155-.804-.069-1.09.217l-4.707 4.707h-2.586c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2h2.586l4.707 4.707c.191.191.447.293.707.293.129 0 .259-.025.383-.076.373-.155.617-.52.617-.924v-18c0-.404-.244-.769-.617-.924zm-1.383 16.51-3.293-3.293c-.187-.188-.442-.293-.707-.293h-3v-6h3c.265 0 .52-.105.707-.293l3.293-3.293z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m19.414 12 1.293-1.293c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-1.293 1.293-1.293-1.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l1.293 1.293-1.293 1.293c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293l1.293-1.293 1.293 1.293c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414z"
})));

var Svg112Mute = function Svg112Mute(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg112Mute, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/112-mute.e39a82c8.svg";
export { ForwardRef as ReactComponent };